import React from 'react';
import { useTranslation } from 'react-i18next';
import Dropzone from 'react-dropzone';

import CardData from '../../../../../../../utils/CardData';
import TabBar from '../../../../../../../utils/TabBar';
import { Divider } from '@material-ui/core';
import DropShadow from '../generalSettingsChild/DropShadow';
import { WidgetProps } from '../../../../../../widgetOverlay/widgetInteractionItem/WidgetProps';

type ImageProps = {
	widgetTemplate: WidgetProps.WidgetTemplate;
	isAtHoverSetting: boolean;
	uploadedFile: {};
	setHoverSetting: (_value: boolean) => {};
	uploadWidgetContent: () => {};
	onUploadFileClick: () => {};
	handleStylingAttributeChange: (_objKey: string | null, _attrKey: string, _value: any) => {};
};

const Image = ({
	widgetTemplate,
	isAtHoverSetting,
	setHoverSetting,
	uploadWidgetContent,
	onUploadFileClick,
	handleStylingAttributeChange
}: ImageProps) => {
	const {
		settings: { bgImgUrl } = { bgImgUrl: '' },
	} = widgetTemplate;

	const { t: translator } = useTranslation();
	return (
		<CardData title={translator('SCENARIO_SCENE_EDITOR_WIDGET_SETTING_CONTENT_IMAGE')}>
			<div className="widget-props-wrapper">
				<div className="scene-widget__control">
					<TabBar
						size="big"
						items={[
							{
								label: translator('SCENARIO_SCENE_EDITOR_WIDGET_SETTING_CONTENT_SETTING_NORMAL'),
								id: 'normal',
								selected: !isAtHoverSetting,
							},
							{
								label: translator('SCENARIO_SCENE_EDITOR_WIDGET_SETTING_CONTENT_SETTING_HOVER'),
								id: 'hover',
								selected: isAtHoverSetting,
							}
						]}
						onItemClick={(_event: any, item: any) => setHoverSetting(item.id === 'hover')}
					/>
				</div>
				<div style={{ marginBottom: "8px" }}>{translator('SCENARIO_SCENE_EDITOR_WIDGET_SETTING_CONTENT_IMAGE')}</div>
				<div className={'scene-widget__control'}>
					<Dropzone multiple={false} accept={'.jpg, .jpeg, .gif, .png, .bmp'} onDrop={uploadWidgetContent}>
						{({ getRootProps, getInputProps }) => (
							<div className="scene-widget__fileUpload--placeholder" onClick={onUploadFileClick}>
								<div {...getRootProps({ className: 'dropzone' })}>
									<input {...getInputProps()} />
								</div>
								<img
									style={{
										height: '100%',
										width: '100%',
									}}
									id="widget-thumbnail"
								/>
							</div>
						)}
					</Dropzone>

					<button className='scene-widget__iconSelector--button' onClick={onUploadFileClick}>
						{isAtHoverSetting && !bgImgUrl
							? translator('SCENARIO_SCENE_EDITOR_WIDGET_SETTING_CONTENT_SETTING_UPLOAD_IMAGE')
							: translator('SCENARIO_SCENE_EDITOR_WIDGET_SETTING_CONTENT_SETTING_REPLACE_IMAGE')}
					</button>
				</div>
				<Divider className="divider-extra-space" />

				<DropShadow
					widgetTemplate={widgetTemplate as any}
					onDropShadowPropChange={(propKey: string, value: any) => handleStylingAttributeChange('transformSettings', propKey, value)}
					showHoverSetting={isAtHoverSetting}
				/>

			</div>
		</CardData>
	);
};

export default Image;
